// Neu (SPEC 03 §11.2) — die Tabelle der Tastenkürzel, geöffnet mit „?“.
// Geändert (01.10.): F und Strg/⌘+K öffnen die Befehlssuche; „/“ führt weiter in die Fragebar.
const ZEILEN: [string, [string[], string][]][] = [
  [
    "Überall",
    [
      [["F"], "Suche: Seiten, Werkzeuge, Codes, Text, KI fragen"],
      [["Strg/⌘", "K"], "ebenso — auch aus einem Eingabefeld"],
      [["/"], "Fragebar (öffnet die Auswertung, wenn nötig)"],
      [["Esc"], "oberste Ebene schließen"],
      [["?"], "diese Übersicht"],
    ],
  ],
  ["Suche", [[["↑", "↓"], "Treffer wählen"], [["Enter"], "öffnen / ausführen"], [["Esc"], "schließen"]]],
  ["Diagramme", [[["←", "→"], "Hervorhebung wandern (↑/↓ bei Querbalken)"], [["Enter"], "filtern und Belege zeigen"], [["Shift", "Enter"], "hinzufügen"]]],
  ["Belege-Dock", [[["j", "k"], "nächste / vorige Karte"], [["Enter"], "im Betrachter öffnen"], [["Esc"], "schließen"]]],
  ["Beleg-Ansicht", [[["←", "→"], "voriger / nächster Beleg der Menge"], [["o"], "Original-PDF (wenn erlaubt)"], [["+", "−", "0"], "zoomen auf der Bühne"], [["Esc"], "zurück"]]],
  [
    "Prüfen",
    [
      [["Enter"], "Übernehmen (Lesefassung: Enter; Wörtlich: Strg/⌘ + Enter)"],
      [["n"], "Lesung N übernehmen"],
      [["e"], "Wörtlich bearbeiten"],
      [["u"], "unleserlich"],
      [["l"], "leer …"],
      [["z", "s"], "zurückstellen"],
      [["v"], "mit dem Ausschnitt verglichen"],
      [["f"], "Frage bestätigen"],
      [["j", "k"], "nächste / vorige Zeile der Warteschlange"],
      [["r"], "neue Region aufziehen"],
      [["Esc"], "Feld verlassen / Zeichnen abbrechen"],
    ],
  ],
  ["Orte prüfen", [[["a"], "Ort annehmen (bzw. gewählte Alternative)"], [["x"], "ablehnen"], [["w"], "anderen Ort wählen"], [["h"], "nur Wohnort (zählt als Stadtteil)"], [["o"], "Wohnort außerhalb der Stadt"], [["j", "k"], "nächster / voriger Vorschlag"]]],
  ["Karte (Auswertung)", [[["←", "→"], "Stadtteil wählen"], [["Enter"], "filtern und Belege zeigen"], [["Shift", "Enter"], "hinzufügen"]]],
  ["Kodieren", [[["1", "…", "9"], "Thema an/aus"], [["Enter"], "bestätigen"], [["x"], "ablehnen"], [["s"], "überspringen"], [["t"], "Teilen"], [["/"], "Themen filtern"], [["j", "k"], "nächste / vorige"]]],
  ["Maskeneditor", [[["Tab"], "Rechtecke wählen"], [["Pfeile"], "bewegen (Shift ×10)"], [["Alt", "Pfeile"], "Größe ändern"], [["Entf"], "entfernen"], [["Esc"], "Zeichnen abbrechen"]]],
  ["Chat", [[["Enter"], "senden"], [["Shift", "Enter"], "neue Zeile"], [["Esc"], "schließen"]]],
];

export function Tastenkuerzel() {
  return (
    <table className="tasten-tabelle">
      <tbody>
        {ZEILEN.map(([bereich, tasten]) => [
          <tr key={bereich + "-kopf"}>
            <th colSpan={2}>{bereich}</th>
          </tr>,
          ...tasten.map(([ks, was], i) => (
            <tr key={bereich + i}>
              <td>
                {ks.map((k) => (
                  <span key={k} className="kbd">
                    {k}
                  </span>
                ))}
              </td>
              <td>{was}</td>
            </tr>
          )),
        ])}
      </tbody>
    </table>
  );
}
